import {
  Outlet,
  useNavigate,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { Suspense, useContext, useEffect, useLayoutEffect, useState } from "react";
import LogoLoader from "../common/components/Loaders/LogoLoader";
import Navbar from "../common/components/Navbar/Navbar";
import ClarityProvider from "../providers/ClarityProvider";
import InstallAppPrompt from "../common/components/InstallAppPrompt/InstallAppPrompt";

/**
 * Reset the scroll position on navigation.
 *
 * The app used to rely on every individual <Link> remembering to call
 * window.scrollTo(0, 0) itself, which left gaps — the footer's links (FootLink)
 * don't, so clicking "About" from the bottom of a long page opened /about
 * already scrolled ~3400px down, mid-article. Doing it here covers every route
 * under Layout at once, so a new link can't reintroduce the bug.
 *
 * Three deliberate exceptions:
 *  - POP (browser back/forward) is left alone, so returning to a page restores
 *    where you were instead of dumping you at the top.
 *  - A #hash link is left alone, so anchor deep-links still jump to their target.
 *  - It keys off `pathname` only, NOT `search` — changing a filter or query
 *    param on a listing page shouldn't yank the user back to the top.
 *
 * useLayoutEffect (not useEffect) so the reset happens before paint; otherwise
 * the new page flashes at the old scroll offset first.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType === "POP" || hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash, navigationType]);

  return null;
};

const Layout = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const loginMode = localStorage.getItem("loginMode");
    const token = localStorage.getItem("token");

  }, []);

  return (
    <>
      <ScrollToTop />
      <ClarityProvider />
      <Navbar />
      <main className="overflow-x-clip">
        <Suspense fallback={<LogoLoader />}>
          <Outlet />
        </Suspense>
      </main>
      {/* Once-per-session "install the app" nudge, phones only. */}
      <InstallAppPrompt />
    </>
  );
};

export default Layout;
